import { useCallback, useState } from 'react';
import { TablePaginationConfig } from 'antd/es/table';
import intl from 'react-intl-universal';

import { listToMap } from '@/utils/transform';
import { getOrderLogByPage } from '@/api/order';

export interface OperationLogData {
  id: string;
  bizTime: number; // 操作时间
  operator: string; // 操作人ID
  operatorName: string; // 操作人名称
  orderNo: string; // 订单号
  systemName: string; // 系统码
  operationPage: string; // 操作页面
  beforeContent: string; // 修改前内容
  afterContent: string; // 修改后内容
  tags: string; // 标签
  operationResult: string; // 操作结果
  inParam: string; // 接口入参
  outParam: string; // 接口出参
}

export type OperationPagination = Pick<TablePaginationConfig, 'current' | 'total' | 'pageSize'>;

// 日志标签
export const OperationTagOption = [
  { label: intl.get('app_constants_booker_name'), value: 'BOOKER' },
  { label: intl.get('app_constants_occupant_name'), value: 'GUEST' },
  { label: intl.get('app_room'), value: 'ROOM' },
  { label: intl.get('channel_standard_price_room_price'), value: 'ROOM_PRICE' },
  { label: intl.get('handover_drawer_category_bill'), value: 'BILL' },
  { label: intl.get('bill_invoice_modal_goods'), value: 'GOODS' },
  { label: intl.get('handover_detail_post_type_11'), value: 'DIRECT_SALE' },
  { label: intl.get('device_peripheral'), value: 'PERIPHERALS' },
];

export const OperationTagMap = listToMap(OperationTagOption);

// 操作结果
export const OperationResultOption = [
  { label: intl.get('bill_refound_res_success'), value: 'SUCCESS' },
  { label: intl.get('bill_refound_res_fail'), value: 'FAILURE' },
];

export const OperationResultMap = listToMap(OperationResultOption);

// 失焦 防止回车时重复提交
const clearActiveElement = () => {
  try {
    if (document && document.activeElement) {
      (document.activeElement as HTMLInputElement).blur();
    }
  } catch (_) {
    //
  }
};

// 列表
export const useLogState = () => {
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [pageState, setPageState] = useState<{
    listData: OperationLogData[];
    pagination: OperationPagination;
  }>({
    listData: [],
    pagination: {
      current: 1,
      pageSize: 50,
      total: 0,
    },
  });

  const queryLogData = useCallback(async (query) => {
    clearActiveElement();
    setLoadingStatus(true);
    try {
      const res = await getOrderLogByPage(query);
      const { list, pageNum, total } = res.data;
      setPageState({
        listData: list || [],
        pagination: {
          current: pageNum || 1,
          pageSize: query.pageSize,
          total: total || 0,
        },
      });
    } catch (_) {
      //
      setPageState({
        listData: [],
        pagination: {
          current: 1,
          pageSize: 50,
          total: 0,
        },
      });
    }
    setLoadingStatus(false);
  }, []);

  return {
    loadingStatus,
    pagination: pageState.pagination,
    dataSource: pageState.listData,
    setLoadingStatus,
    queryLogData,
  };
};
